/* panel-action-group.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu82ADO%7Bgap%3Avar(--ds-space-100%2C8px)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D");


import type { ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
export interface PanelActionGroupProps {
  /**
   * The action components to group together.
   */
  children: ReactNode;
  /**
   * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
   */
  testId?: string;
}
const styles = {
  group: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
};

/**
 * The PanelActionGroup component provides a container for grouping
 * panel actions together with consistent spacing and layout.
 */
export function PanelActionGroup({
  children,
  testId
}: PanelActionGroupProps): JSX.Element {
  return <Box testId={testId} xcss={styles.group}>
			{children}
		</Box>;
}